export default "__VITE_PUBLIC_ASSET__770172bc__"